import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

import appEnv from '@/support/env'

/**
 * Sentry, with browser tracing keyed to the router and session replay.
 *
 * `captureConsoleIntegration` means a `console.error` anywhere becomes an event — which is
 * the other half of why `console.*` is banned in the adok layers (see fsd-styling.md): a
 * stray debug line is not free here, it is an alert.
 */
export function installErrorLogger(
  app: App,
  router: Router,
  dsn: string | null
) {
  if (!dsn?.length) return

  Sentry.init({
    app,
    dsn,
    environment: appEnv.ENV || 'beta',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] })
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Browser extensions (ad blockers and friends) throw inside our pages and report as
    // our errors; nothing here can fix those.
    denyUrls: [/^chrome-extension:\/\//i]
  })
}
